import useIntl from '@/utils/intl'
import Image from 'next/image'
import React, { FunctionComponent, useEffect } from 'react'
import { ArrowForward } from '@mui/icons-material'
import { HomeBanner } from '@/services/cms-api/home-page-content/types'
import { useLanguage } from '@/context/LanguageContext'
import { Dialog, Slide, useMediaQuery } from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import Bill from './bill'
import Data from './data'
import Sim from './sim'
import { useRouter, usePathname, useSearchParams } from 'next/navigation'
import { IMG_URL } from '@/utils/constants'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-fade'
import { EffectFade, Autoplay, Pagination } from 'swiper/modules'
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled'
import StopCircleIcon from '@mui/icons-material/StopCircle'
import theme from '@/styles/theme'
import MffNumber from '@/pages/newnumberv2'
import classNames from 'classnames'
import { useTheme } from '@/context/ThemeContext'
import WifiCard from './wifiCard'
import UnitServices from './unitServices'
import LeasingServices from '@/pages/handsetDti'

interface Menu {
  name: string
  icon: string
  action: string
  id: string
}

interface Prop {
  banners: HomeBanner[]
}

const Transition = React.forwardRef(function Transition (
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction='up' ref={ref} {...props} />
})

const Top: FunctionComponent<Prop> = ({ banners }) => {
  const { translate } = useIntl()
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { theme: mode } = useTheme()
  const { locale } = useLanguage()
  const [clickedAction, setClickedAction] = React.useState<
  string | undefined
  >()
  const [open, setOpen] = React.useState(false)
  const [paused, setPaused] = React.useState(false)
  const [swiper, setSwiper] = React.useState<
    typeof Swiper | undefined
  >() as any
  const [progress, setProgress] = React.useState(0)
  const [intervalId, setIntervalId] = React.useState<any>()
  const [isIphoneClient, setIsIphoneClient] = React.useState<boolean>(false)
  const duration = 5000
  const steps = 100
  const interval = duration / steps
  const [activeTab, setActiveTab] = React.useState<string>('quickaction')

  const menus: Menu[] = [
    {
      name: translate('quick.buyUnit'),
      icon: '/uploads/icons/phone.svg',
      action: 'unit',
      id: 'quick.buyUnit'
    },
    {
      name: translate('quick.buyData'),
      icon: '/uploads/icons/Data.svg',
      action: 'data',
      id: 'quick.buyData'
    },
    {
      name: translate('quick.simRecover'),
      icon: '/uploads/icons/simRecover.svg',
      action: 'sim',
      id: 'quick.recoverSim'
    },
    {
      name: translate('quick.payBill'),
      icon: '/uploads/icons/wallet-plus.svg',
      action: 'bill',
      id: 'quick.payBill'
    },
    {
      name: translate('quick.leasing'),
      icon: '/uploads/icons/handset-dti.svg',
      action: 'leasing',
      id: 'quick.leasing'
    },
    // {
    //   name: translate('shop'),
    //   icon: phoneIcon,
    //   action: 'handset'
    // },
    // {
    //   name: "MNP75",
    //   icon: "/uploads/icons/MNP75.svg",
    //   action: "mnp75",
    //   id: "quick.mnp75",
    // },
    {
      name: translate('quick.newNumber'),
      icon: '/uploads/icons/memory-card.svg',
      action: 'number',
      id: 'quick.newNumber'
    }
  ]
  const menus2: Menu[] = [
    {
      name: translate('quick.mnp75'),
      icon: '/uploads/icons/phone.svg',
      action: 'unit',
      id: 'quick.buyUnit'
    },
    {
      name: translate('quick.wifiCard'),
      icon: '/uploads/icons/MNP75.svg',
      action: 'wifiCard',
      id: 'quick.wifiCard'
    },
    {
      name: translate('quick.payBill'),
      icon: '/uploads/icons/wallet-plus.svg',
      action: 'bill',
      id: 'quick.payBill'
    },
    {
      name: translate('quick.myInternet'),
      icon: '/uploads/icons/Data.svg',
      action: 'data',
      id: 'quick.buyData'
    }
  ]

  useEffect(() => {
    const userAgent = navigator.userAgent ?? (window as any).opera
    setIsIphoneClient(userAgent.includes('iPhone'))
  }, [])

  useEffect(() => {
    handleModal()
  }, [searchParams])

  useEffect(() => {
    const id = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress < 100) {
          return prevProgress + 1
        }
        return 100
      })
    }, interval)
    setIntervalId(id)
    return () => clearInterval(id)
  }, [progress])

  const stopInterval = (): void => {
    clearInterval(intervalId)
  }

  const startProgressBar = (): void => {
    setProgress(0)
  }
  const handleButtonClick = (): void => {
    if (paused) {
      swiper?.autoplay.start()
      startProgressBar()
      setPaused(false)
    } else {
      swiper?.autoplay.pause()
      stopInterval()
      setPaused(true)
    }
  }
  const handleModal = (): void => {
    const action = searchParams.get('open')
    if (action === null) {
      setOpen(false)
    } else {
      setClickedAction(action)
      setOpen(true)
    }
  }

  const handleOpen = (item: Menu): void => {
    const isFromMenus2 = activeTab === 'handset'

    if (item.action === 'number' && isIphoneClient) {
      router.push('newnumberv2')
    } else {
      const url = pathname + `?open=${item.action}${isFromMenus2 && item.action === 'unit' ? '&mnp=true' : ''}`
      router.push(url)
    }
  }

  const handleClose = (): void => {
    router.push(pathname)
    setOpen(false)
  }
  if (banners === undefined || banners === null) {
    return <></>
  }
  return (
    <div id='top' className='w-full flex justify-center'>
      <Swiper
        modules={[EffectFade, Autoplay, Pagination]}
        pagination={{
          clickable: true
        }}
        autoplay={{
          delay: duration
        }}
        speed={700}
        effect='fade'
        loop={Boolean(true)}
        className='swiper rounded-xl bg-cover transition-all ease-linear w-[95vw] bg-gray'
        onSwiper={(swiper?) => setSwiper(swiper)}
        onSlideChange={() => {
          swiper?.autoplay.start()
          setPaused(false)
          startProgressBar()
        }}
      >
        {banners.map((item: HomeBanner, i: number) => (
          <SwiperSlide key={i} className='rounded-xl ease-linear w-[95vw]'>
            {
              // item.image.split('.').pop() === 'webp'
              //   ? (
              <div
                className='rounded-xl bg-cover ease-linear w-[95vw]'
                style={{ backgroundImage: `url(${IMG_URL + item.image})` }}
              >
                <div className='h-full w-full bg-gradient-to-t from-black/60 rounded-xl flex flex-col md:flex-row 2xl:p-36 xl:p-24 lg:p-20 md:p-12 p-4 justify-between items-end'>
                  <div className='md:mb-10 mt-12 md:mt-0 md:w-1/2 min-h-[432px]'>
                    <p className='2xl:text-[55px] xl:text-5xl text-4xl text-textAdditional transition-all duration-700 ease-linear font-extrabold text-center flex items-end h-32 md:h-44 md:text-left 2xl:w-5/6 md:w-4/5'>
                      {locale === 'en' ? item.titleEn : item.titleMn}
                    </p>
                    <p className='text-textAdditional lg:text-lg md:text-base text-sm font-semibold lg:mt-6 mt-3 text-center md:text-left'>
                      {locale === 'en' ? item.subtitleEn : item.subtitleMn}
                    </p>
                    <div className='flex items-center mt-10 justify-center md:justify-start'>
                      <p className='text-textAdditional lg:text-base md:text-base text-opacity-90 font-medium text-center md:text-left px-3 transition-transform'>
                        {(i + 1).toString() + '/' + banners.length.toString()}
                      </p>
                      <div className='w-[40%] rounded-md flex items-center bg-white/30 h-[6px]'>
                        <div
                          id='progress-bar'
                          className='h-[6px] bg-textAdditional rounded-md transition ease-in-out flex justify-center'
                          style={{ width: `${progress}%` }}
                        />
                      </div>
                      {paused
                        ? (
                          <PlayCircleFilledIcon
                            color='primary'
                            className='mx-2 hover:cursor-pointer'
                            onClick={() => {
                              handleButtonClick()
                            }}
                          />
                          )
                        : (
                          <StopCircleIcon
                            color='primary'
                            className='mx-2 hover:cursor-pointer'
                            onClick={() => {
                              handleButtonClick()
                            }}
                          />
                          )}
                    </div>
                  </div>
                  <div className='p-3 rounded-3xl h-fit bg-white/10 backdrop-blur-xl xl:w-[522px] lg:w-[474px] md:w-[375px] w-full mt-12 md:mt-0'>
                    <ul className='bg-surfaceInverse85 flex items-center justify-between p-2 gap-2 rounded-xl'>
                      <li
                        className={classNames(
                          'px-4 md:px-8 py-2 rounded-xl font-semibold transition-all duration-500 ease-in-out text-xs lg:text-sm w-full text-center cursor-pointer',
                          activeTab === 'quickaction'
                            ? 'bg-secondaryAdditional text-textAdditional'
                            : 'bg-gray-200 text-gray-600'
                        )}
                        onClick={() => setActiveTab('quickaction')}
                      >
                        {translate('quickaction')}
                      </li>
                      <li
                        className={classNames(
                          'px-4 md:px-8 py-2 rounded-xl font-semibold transition-all duration-500 ease-in-out text-xs lg:text-sm w-full text-center cursor-pointer',
                          activeTab === 'handset'
                            ? 'bg-secondaryAdditional text-textAdditional'
                            : 'bg-gray-200 text-gray-600'
                        )}
                        onClick={() => setActiveTab('handset')}
                      >
                        {translate('quickaction1')}
                      </li>
                    </ul>
                    {/* <div className='bg-surfaceInverse85 rounded-2xl mt-3 p-4 flex gap-4'>
                      {activeTab === 'quickaction'
                        ? (
                          <div className='grid grid-cols-2 w-full gap-2'>
                            {menus.map((subitem: Menu, subi: number) => (
                              <div
                                key={subi}
                                className={classNames(
                                  'group/item h-32 cursor-pointer flex flex-col justify-center items-center rounded-xl hover:border-2 hover:bg-surfaceInverse transition-all duration-300',
                                  mode === 'light'
                                    ? 'hover:border-[#FEF2F2]'
                                    : 'hover:border-secondaryMidStroke'
                                )}
                                onClick={() => handleOpen(subitem)}
                              >
                                <div className='group/edit flex justify-center items-center w-16 p-3 rounded-full border group-hover/item:bg-surfaceInverse  transition-all duration-300 bg-[#FEF2F2] shadow-[inset_0_0_4px_0_rgba(248,113,113,1)] group-hover/item:shadow-[0_0_8px_0_rgba(248,113,113,1)]'>
                                  <Image
                                    draggable={false}
                                    src={IMG_URL + subitem.icon}
                                    alt='?'
                                    width={16}
                                    height={16}
                                    className='w-9'
                                  />
                                </div>
                                <p className='group/edit mt-3 font-semibold flex items-center transition-all duration-300 text-xs md:text-sm text-neutral group-hover/item:-translate-x-2 text-textHigh'>
                                  {subitem.name}{' '}
                                  <ArrowForward className='hidden text-base group/edit group-hover/item:flex ml-2 transition-all duration-300' />
                                </p>
                              </div>
                            ))}
                          </div>
                          )
                        : (
                          <div className='grid grid-cols-2 w-full gap-2'>
                            {menus2.map((subitem: Menu, subi: number) => (
                              <div
                                key={subi}
                                className={classNames(
                                  'group/item h-32 cursor-pointer flex flex-col justify-center items-center rounded-xl hover:border-2 hover:bg-surfaceInverse transition-all duration-300',
                                  mode === 'light'
                                    ? 'hover:border-[#FEF2F2]'
                                    : 'hover:border-secondaryMidStroke'
                                )}
                                onClick={() => handleOpen(subitem)}
                              >
                                <div className='group/edit flex justify-center items-center w-16 p-3 rounded-full border group-hover/item:bg-surfaceInverse  transition-all duration-300 bg-[#FEF2F2] shadow-[inset_0_0_4px_0_rgba(248,113,113,1)] group-hover/item:shadow-[0_0_8px_0_rgba(248,113,113,1)]'>
                                  <Image
                                    draggable={false}
                                    src={IMG_URL + subitem.icon}
                                    alt='?'
                                    width={16}
                                    height={16}
                                    className='w-9'
                                  />
                                </div>
                                <p className='group/edit mt-3 font-semibold flex items-center transition-all duration-300 text-xs md:text-sm text-neutral group-hover/item:-translate-x-2 text-textHigh'>
                                  {subitem.name}{' '}
                                  <ArrowForward className='hidden text-base group/edit group-hover/item:flex ml-2 transition-all duration-300' />
                                </p>
                              </div>
                            ))}
                          </div>
                          )}
                    </div> */}
                    <div className='bg-surfaceInverse85 rounded-2xl mt-3 p-4 flex gap-4'>
                      <div className='grid grid-cols-2 w-full gap-2 auto-rows-[8rem] min-h-[25rem]'>
                        {(activeTab === 'quickaction' ? menus : menus2).map(
                          (subitem: Menu, subi: number) => (
                            <div
                              key={subi}
                              className={classNames(
                                'group/item h-32 cursor-pointer flex flex-col justify-center items-center rounded-xl hover:border-2 hover:bg-surfaceInverse transition-all duration-300',
                                mode === 'light'
                                  ? 'hover:border-[#FEF2F2]'
                                  : 'hover:border-secondaryMidStroke'
                              )}
                              onClick={() => handleOpen(subitem)}
                            >
                              <div className='group/edit flex justify-center items-center w-16 p-3 rounded-full border group-hover/item:bg-surfaceInverse transition-all duration-300 bg-[#FEF2F2] shadow-[inset_0_0_4px_0_rgba(248,113,113,1)] group-hover/item:shadow-[0_0_8px_0_rgba(248,113,113,1)]'>
                                <Image
                                  draggable={false}
                                  src={IMG_URL + subitem.icon}
                                  alt={subitem.name}
                                  width={16}
                                  height={16}
                                  className='w-9'
                                />
                              </div>
                              <p className='group/edit mt-3 font-semibold flex items-center transition-all duration-300 text-xs md:text-sm text-neutral group-hover/item:-translate-x-2 text-textHigh'>
                                {subitem.name}{' '}
                                <ArrowForward className='hidden text-base group/edit group-hover/item:flex ml-2 transition-all duration-300' />
                              </p>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              // )
              // : (
              //   <div className='rounded-xl bg-cover ease-linear w-[95vw]'>
              //     <video
              //       src={item.image}
              //       autoPlay
              //       muted
              //       loop
              //       className='absolute top-0 rounded-xl ease-linear bg-cover w-full h-full p-0 object-cover z-0'
              //       autoFocus
              //     />
              //     {/* <ReactPlayer
              //       url={item.image}
              //       controls={Boolean(true)}
              //       className='absolute top-0 rounded-xl ease-linear bg-cover w-full h-full p-0 object-cover z-0'
              //     />
              //     <source src={item.image} type='video/mp4' className='absolute top-0 rounded-xl ease-linear bg-cover w-full h-full p-0 object-cover z-0' /> */}
              //     {/* <video ref={vidRef}>
              //       <source src={item.image} type='video/mp4' />
              //     </video> */}
              //     <div className='h-full w-full bg-gradient-to-t from-black/60 rounded-xl flex flex-col md:flex-row 2xl:p-36 xl:p-24 lg:p-20 md:p-12 p-4 justify-between items-end'>
              //       <div className='md:mb-10 mt-12 md:mt-0 md:w-1/2 bg-black'>
              //         <p className='2xl:text-[55px] xl:text-5xl text-4xl text-textInverse transition-all duration-700 ease-linear font-extrabold text-center flex items-end h-32 md:h-44 md:text-left 2xl:w-5/6 md:w-4/5'>{locale === 'en' ? item.titleEn : item.titleMn}</p>
              //         <p className='text-[#ECECEC] lg:text-lg md:text-base text-sm font-semibold lg:mt-6 mt-3 text-center md:text-left'>{locale === 'en' ? item.subtitleEn : item.subtitleMn}</p>
              //       </div>
              //       <div className='p-3 rounded-3xl h-fit bg-white/10 backdrop-blur-xl xl:w-[522px] lg:w-[474px] md:w-[375px] w-full mt-12 md:mt-0'>
              //         <ul className='bg-surfaceInverse flex items-center justify-between p-2 gap-2 rounded-xl'>
              //           <li className='px-4 md:px-8 py-2 rounded-xl font-semibold transition-all duration-500 ease-in-out text-xs lg:text-sm w-full text-center bg-[#27272A] text-textInverse'>{translate('quickaction')}</li>
              //         </ul>
              //         <div className='bg-surfaceInverse/90 rounded-2xl mt-3 p-4 flex gap-4'>
              //           <div className='grid grid-cols-2 w-full gap-2'>
              //             {menus.map((subitem: Menu, subi: number) => (
              //               <div key={subi} className='group/item h-32 cursor-pointer flex flex-col justify-center items-center rounded-xl hover:border-2 hover:border-[#FEF2F2] hover:bg-surfaceInverse transition-all duration-300' onClick={subitem.action === 'number' ? () => setOpen(false) : () => handleOpen(subitem)}>
              //                 <div className={classNames('group/edit flex justify-center items-center w-16 p-3 rounded-full border group-hover/item:bg-surfaceInverse  transition-all duration-300', subitem.action === 'number' ? 'bg-[#F7F7F7] shadow-[inset_0_0_4px_0_rgba(212,212,212,1)]' : 'bg-[#FEF2F2] shadow-[inset_0_0_4px_0_rgba(248,113,113,1)] group-hover/item:shadow-[0_0_8px_0_rgba(248,113,113,1)]')}>
              //                   <Image draggable={false} src={IMG_URL + subitem.icon} alt='?' width={16} height={16} className='w-9' />
              //                 </div>
              //                 <p className={classNames('group/edit mt-3 font-semibold flex items-center transition-all duration-300 text-xs md:text-sm', subitem.action === 'number' ? 'group-hover/item:hidden text-[#B0B0B0]' : 'text-neutral group-hover/item:-translate-x-2')}>{subitem.name} <ArrowForward className={classNames('hidden text-base', subitem.action === 'number' ? '' : 'group/edit group-hover/item:flex ml-2 transition-all duration-300')} /></p>
              //                 <p className={classNames('group/edit mt-3 text-textMid font-semibold hidden items-center transition-all duration-300 text-xs md:text-sm', subitem.action === 'number' ? 'group-hover/item:flex' : 'hidden')}>{translate('soon')}</p>
              //               </div>
              //             ))}
              //           </div>
              //         </div>
              //       </div>
              //     </div>
              //   </div>
              //   )
            }
          </SwiperSlide>
        ))}
      </Swiper>
      <Dialog
        fullWidth
        fullScreen={useMediaQuery(theme.breakpoints.down('sm'))}
        maxWidth='xl'
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        {open && clickedAction !== undefined && (
          <>
            {clickedAction === 'unit' && <UnitServices onClose={handleClose} />}
            {clickedAction === 'bill' && <Bill onClose={handleClose} />}
            {clickedAction === 'data' && <Data onClose={handleClose} />}
            {clickedAction === 'sim' && <Sim onClose={handleClose} />}
            {clickedAction === 'wifiCard' && <WifiCard onClose={handleClose} />}
            {clickedAction === 'number' && <MffNumber onClose={handleClose} />}
            {clickedAction === 'leasing' && (
              <LeasingServices onClose={handleClose} onContinue={() => {}} />
            )}
          </>
        )}
      </Dialog>
    </div>
  )
}
export default Top
